import { createSlice } from '@reduxjs/toolkit';

export const options = createSlice({
    name: 'options',
    initialState: {},
    reducers: {
        optionsLagret: (state, action) => {
            return action.payload;
        },
    },
});

export const { optionsLagret } = options.actions;
export default options.reducer;